export function getAttributeError(type: string, id: string): string {
    return `${type}.${id}`;
}